module.exports = __webpack_public_path__ + "pic3.jpg?b6fb34398cbe281c2837dd6f559a653d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/featured/pic3.jpg
// module id = 61
// module chunks = 13